<template>
    <div class="new-icons">
        <h3>Выберите иконку места</h3>
        <div class="new-icons-body">
            <slot v-for="(icon, name, index) in icons">
                <div 
                    class="new-icons__item" 
                    v-if="name !== 'flag'" 
                    :class="{active: active == name}" 
                    @click="changeIcon(name)" 
                    :key="index"
                    v-html="icon(active === name ? '#53cbb5' : '#2d2c3a')"
                    :title="getTitle(name)"
                ></div>
            </slot>
        </div>
    </div>
</template>
<script>
import icons from '@/components/Icons/places/index.js'
export default {
    name: 'ChoiseIcons',
    data: () => {
        return {
            icons,
            active: 'flag'
        }
    },
    computed: {
        getIcons() {
            let new_icons = icons;
            delete new_icons.flag;
            return new_icons
        }
    },
    methods: {
        changeIcon(name) {
            this.active = name;
            this.$emit('changeIcon', name)
        },
        getTitle(name) {
            let names = {
                longboarding: 'Трасса для спуска',
                skatepark: 'Скейт-парк',
                slope: 'Горнолыжный склон',
                resort: 'Горнолыжный курорт',
                flag: 'Место'
            };
            return names[name]
        }
    }
    
}
</script>